import supabase from './supabaseClient';
import React, { } from "react";
import logUserAction from "./Logging";

var pageName = 'Profile'; // Default page name
// var selectedCategory = 'null'; // Default category
var currentuserid = '';

// Check if the URL has a query string and extract the CategoryName if it exists
let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'pageName') {
      pageName = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

if((pageName === 'Login' || pageName === 'Register'))
{
  // no action
}
if (pageName === 'Profile')
{
  if ((!currentuserid || currentuserid === ''))  // Check if user is logged in
  {
    //alert(1);
    handleGuestLogin();
  }
  else
  {
    // check user token
    const { data, error } = await supabase
      .from('UserSessions')
      .select('userid, token, created_at, Users(isguest)')
      .eq('token', currentuserid.substring(currentuserid.indexOf('-') + 1))
      .single();
    
    if (error) {
      //alert('Error checking session. Please login again.' + error.message);
      handleGuestLogin();
    }

    // if userid if same as in currentuserid then proceed else navigate to login page
    if (!data) {
      //alert('Session data not found. Please login again.');
      handleGuestLogin();
    }

    // if userid if same as in currentuserid then proceed else navigate to login page
    if (parseInt(data.userid, 10) !== parseInt(currentuserid.split('-')[0], 10)) {
      //alert('Invalid session found. Please login again.');
      handleGuestLogin();
    }

    // if token was created in last 1 hour then proceed else navigate to login page
    const tokenCreationTime = new Date(data.created_at);
    const currentTime = new Date();
    const timeDifference = (currentTime - tokenCreationTime) / (1000 * 60); // difference in minutes
    console.log('Time calculation is for guest?:', data.Users.isguest);
    const allowedTimeDifference = data.Users.isguest ? 10 : 60; // 2 minutes for guests, 60 minutes for others
    if (timeDifference > allowedTimeDifference) {
      // Show session timeout message based on user type
      if (data.Users.isguest) {
      alert('Your guest session has expired. Please login or register to continue.');
      } else {
      alert('Your session has timed out. Please login again.');
      }
      handleGuestLogin();
    }
}
}

async function handleGuestLogin() {
  logUserAction(0, 'User not logged in. generating guest login.');

  try {
    // const guestNameInput = document.getElementById('guestName');
    // const guestName = guestNameInput && guestNameInput.value.trim();

    // if (!guestName) {
    //   alert('Please enter your name. This is only for display on the screen during this session and will not be used for any other purpose.');
    //   return;
    // }

    let userIp = 'NA';
    try {
      const ipResponse = await fetch('https://api.ipify.org?format=json');
      const ipData = await ipResponse.json();
      userIp = ipData.ip || 'NA';
    } catch (error) {
      console.error('Failed to fetch user IP:', error);
    }

    const guestName = 'Guest';
    const { data, error } = await supabase
      .from('Users')
      .insert([{ username: guestName, isguest: true, active: true }])
      .select('userid')
      .single();

    if (error) {
      alert('Failed to create guest user: ' + error.message);
      return;
    }

    const guestUserId = data.userid;

    // Create a new session entry for the guest user
    const { data: sessionData, error: sessionError } = await supabase
      .from('UserSessions')
      .insert([{ userid: guestUserId, userip: userIp }])
      .select('token')
      .single();

    if (sessionError) {
      alert('Failed to create guest session: ' + sessionError.message);
      return;
    }

    // Redirect to the profile page with the guest session token
    window.location.href = '/?pageName=Profile&userid=' + guestUserId + '-' + sessionData.token;
  } catch (err) {
    console.error('Unexpected error:', err);
    alert('An unexpected error occurred. Please try again later.');
  }
};

async function navigatetoLoginPage(){
  logUserAction(0, 'User not logged in. Please login to continue.');
  window.location.href = window.location.pathname + "?pageName=Login&userid=" + currentuserid;
  return;
};

function Profile() { 
  const [username, setUsername] = React.useState('');
  const [isguest, setisguest] = React.useState('');


  React.useEffect(() => {
    async function fetchUsername() {
      if (currentuserid) {
        const { data } = await supabase
          .from('Users')
          .select('username, isguest')
          .eq('userid', currentuserid.split('-')[0])
          .single();

        if (data && data.username) {
          setUsername(data.username);
          setisguest(String(data.isguest));
          console.log('point1');
          console.log(data);
        }
      }
    }
    fetchUsername();
  }, []); //currentuserid

  function navigateToCategoryPage() {
    logUserAction(currentuserid,'Profile page: clicked Select Category button');

    // check if isguest is true then show notification alert to user reminding that their scores will not be tracked as guest. 
    // show 2 buttons 'continue as guest' and 'Log in' and navigate accordingly
    if (isguest === 'true') {
      setOverlayContent({
        title: "Guest User Notice",
        content: (
          <div style={{
        maxHeight: '50vh', // Limit the height to 50% of the viewport height
        maxWidth: '80vw', // Limit the width to 80% of the viewport width
        overflow: 'auto', // Add both vertical and horizontal scrollbars if content overflows
        padding: '10px',
        textAlign: 'left',
        fontFamily: 'Arial, sans-serif',
        lineHeight: '1.6',
        color: '#333',
          }}>
        <p>As a guest, your scores will not be saved. Please choose an option:</p>
          </div>
        ),
        onAccept: () => {
          setOverlayContent(null); // Close the popup
          window.location.href = window.location.pathname + "?pageName=Category&userid=" + currentuserid;
        },
        onReject: () => {
          setOverlayContent(null); // Close the popup
          navigatetoLoginPage(); // Navigate to login page
        },
        acceptButtonText: "Continue As Guest",
        rejectButtonText: "Log In"
      });
    }
    else
    {
      window.location.href = window.location.pathname + "?pageName=Category&userid=" + currentuserid;
    }
  };

  function navigateToFriendsPage() {
    logUserAction(currentuserid,'Profile page: clicked Friends button');
    window.location.href = window.location.pathname + "?pageName=Friends&userid=" + currentuserid;
    return;
  };

  function navigateToTeamPage() {
    logUserAction(currentuserid,'Profile page: clicked Team button');
    window.location.href = window.location.pathname + "?pageName=Team&userid=" + currentuserid;
    return;
  };

  function navigatetoPointsPage() {
    logUserAction(currentuserid,'Profile page: clicked Points button');
    window.location.href = window.location.pathname + "?pageName=MyScore&userid=" + currentuserid;
    return;
  };

  function navigatetoKnowledgeScorePage() {
    logUserAction(currentuserid,'Profile page: clicked Knowledge score button');
    window.location.href = window.location.pathname + "?pageName=MyKnowledgeScore&userid=" + currentuserid;
    return;
  };

  function navigatetoLeaderboardPage(){
    logUserAction(currentuserid,'Profile page: clicked Leaderboard button');
    window.location.href = window.location.pathname + "?pageName=Leaderboard&userid=" + currentuserid;
    return;
  }

  function navigatetoChallengesPage(){
    logUserAction(currentuserid,'Profile page: clicked Challenges button');
    
    // check if isguest is true then show notification alert to user reminding that their scores will not be tracked as guest. 
    // show 2 buttons 'continue as guest' and 'Log in' and navigate accordingly
    if (isguest === 'true') {
      setOverlayContent({
        title: "Guest User Notice",
        content: (
          <div>
        <p>As a guest, your scores will not be saved. Please choose an option:</p>
          </div>
        ),
        onAccept: () => {
          setOverlayContent(null); // Close the popup
          window.location.href = window.location.pathname + "?pageName=Challenges&userid=" + currentuserid;
        },
        onReject: () => {
          setOverlayContent(null); // Close the popup
          navigatetoLoginPage(); // Navigate to login page
        },
        acceptButtonText: "Continue As Guest",
        rejectButtonText: "Log In"
      });
      // </div>

      // if (!userChoice) {
      //   navigatetoLoginPage();
      //   return;
      // }
    }
    else{
      window.location.href = window.location.pathname + "?pageName=Challenges&userid=" + currentuserid;
    }
    //window.location.href = window.location.pathname + "?pageName=Challenges&userid=" + currentuserid;
    //return;
  }


  const navigateToVouchersPage = () => {
    logUserAction(currentuserid,'Profile page: clicked Vouchers button');
    window.location.href = window.location.pathname + "?pageName=Vouchers&userid=" + currentuserid;
    return;
  };

  const [showMyPoints, setShowMyPoints] = React.useState(true);
  const [showMyTeam, setShowMyTeam] = React.useState(true);
  const [showMyFriends, setShowMyFriends] = React.useState(true);
  const [showVouchers, setShowVouchers] = React.useState(true);
  const [showLeaderboard, setShowLeaderboard] = React.useState(true);
  const [showChallenges, setShowChallenges] = React.useState(true);

  // fetch app config data
  React.useEffect(() => {
    async function fetchAppConfig() {
      const { data } = await supabase
        .from('AppConfig')
        .select('key, value')
        .in('key', ['show_mypoints_button', 'show_myfriends_button', 'show_myteam_button', 'show_vouchers_button', 'show_leaderboard_button', 'show_challenges_button']);

        if (data) {
        const pointsConfig = data.find(item => item.key === "show_mypoints_button");
        setShowMyPoints(pointsConfig ? pointsConfig.value === "true" : false);

        const teamConfig = data.find(item => item.key === "show_myteam_button");
        setShowMyTeam(teamConfig ? teamConfig.value === "true" : false);

        const friendsConfig = data.find(item => item.key === "show_myfriends_button");
        setShowMyFriends(friendsConfig ? friendsConfig.value === "true" : false);

        const vouchersConfig = data.find(item => item.key === "show_vouchers_button");
        setShowVouchers(vouchersConfig ? vouchersConfig.value === "true" : false);

        const leaderboardConfig = data.find(item => item.key === "show_leaderboard_button");
        setShowLeaderboard(leaderboardConfig ? leaderboardConfig.value === "true" : false);

        const challengesConfig = data.find(item => item.key === "show_challenges_button");
        setShowChallenges(challengesConfig ? challengesConfig.value === "true" : false);
      }
    }
    fetchAppConfig();
  }, []);

  const [points, setPoints] = React.useState(0);

  //fetch points
  React.useEffect(() => {
    async function fetchPoints() {
      if (currentuserid) {
        const { data } = await supabase
          .from('UserResponses')
          .select('PointsReceived')
          .eq('userid', currentuserid.split('-')[0])
          .is('voucherid', null)
          .eq('PointsRedeemed', false);

        if (data && data.length > 0) {
            const totalPoints = data.reduce((sum, row) => sum + (row.PointsReceived || 0), 0);
            setPoints(totalPoints);
        }
      }
    }
    fetchPoints();
  }, []); //currentuserid

  const [teamCount, setTeamCount] = React.useState(0);

  //fetch team count
  React.useEffect(() => {
    async function fetchTeamCount() {
      if (currentuserid) {
        const { count } = await supabase
          .from('Users')
          .select('userid', { count: 'exact', head: true })
          .eq('referredby', currentuserid.split('-')[0]);

        if (typeof count === 'number') {
          setTeamCount(count);
        }
      }
    }
    fetchTeamCount();
  }, []); //currentuserid

  const [voucherCount, setVoucherCount] = React.useState(0);

  // fetch voucher count
  React.useEffect(() => {
    async function fetchVoucherCount() {
      if (currentuserid) {
        const { count } = await supabase
          .from('Vouchers')
          .select('id', { count: 'exact', head: true })
          .eq('userid', currentuserid.split('-')[0]);

        if (typeof count === 'number') {
          setVoucherCount(count);
        }
      }
    }
    fetchVoucherCount();
  }, []);  //currentuserid

  //* Define userStats state before using it */
  const fetchUserStats = async () => {
    if (currentuserid) {
      try {
        const response = await fetch('https://kc-service-eight.vercel.app/profile_userstats', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId: currentuserid.split('-')[0] })
        });
        const data = await response.json();
        setUserStats(data);
        console.log('Fetched user stats:', data);
      } catch (err) {
        setUserStats({ error: 'Failed to fetch user stats.', details: err.message });
      }
    }
  }

  const [userStats, setUserStats] = React.useState(null);
  React.useEffect(() => {
    fetchUserStats();
  }, []);  //currentuserid

  const [overlayContent, setOverlayContent] = React.useState(null); // Define overlay content state
  const [userAgreed, setUserAgreed] = React.useState(false); // Define user agreement state

  //checkTermsAndConditions
  React.useEffect(() => {
    async function checkTermsAndConditions() {
      if (currentuserid) {
        try {
          // Fetch termscheck date for the user
          const { data: userTermsData, error: userTermsError } = await supabase
            .from('Users')
            .select('termscheck')
            .eq('userid', currentuserid.split('-')[0])
            .single();

          if (userTermsError || !userTermsData) {
            console.error('Error fetching user termscheck date:', userTermsError);
            return;
          }

          const userTermsCheckDate = new Date(userTermsData.termscheck);

          // Fetch termschanged date from AppConfig
          const { data: appConfigData, error: appConfigError } = await supabase
            .from('AppConfig')
            .select('value')
            .eq('key', 'termschanged')
            .single();

          if (appConfigError || !appConfigData) {
            console.error('Error fetching termschanged date:', appConfigError);
            return;
          }

          const termsChangedDate = new Date(appConfigData.value);

          // Compare dates
          if (userTermsCheckDate < termsChangedDate) {
            const { data: termsData, error: termsError } = await supabase
              .from('AppConfig')
              .select('value')
              .eq('key', 'termsandconditions')
              .single();

            if (termsError || !termsData) {
              console.error('Error fetching terms and conditions:', termsError);
              return;
            }

            const termsContent = termsData.value;

            setOverlayContent({
              title: "",
              content: <div 
                style={{
                    textAlign: "left", // Ensures text is left-aligned
                    fontFamily: "Arial, sans-serif",
                    lineHeight: "1.6",
                    color: "#333",
                  }} 
                  dangerouslySetInnerHTML={{ __html: termsContent }} />,
              onAccept: async () => {
              // Update termscheck date for the user
              const { error: updateError } = await supabase
                .from('Users')
                .update({ termscheck: new Date().toISOString() })
                .eq('userid', currentuserid.split('-')[0]);

              if (updateError) {
                console.error('Error updating termscheck date:', updateError);
              } else {
                setOverlayContent(null); // Close the overlay
                setUserAgreed(true); // Mark user as agreed
              }
              },
              onReject: () => {
              // Close session and navigate to login page
              setOverlayContent(null); // Close the overlay
              setUserAgreed(false); // Mark user as not agreed
              handleGuestLogin();
              }
            });

            // Wait for user response before proceeding
            const waitForUserResponse = async () => {
              return new Promise((resolve) => {
              const interval = setInterval(() => {
                if (userAgreed !== null) {
                clearInterval(interval);
                resolve();
                }
              }, 100);
              });
            };

            await waitForUserResponse();
          }
        } catch (err) {
          console.error('Error checking terms and conditions:', err);
        }
      }
    }

    checkTermsAndConditions();
  }, [userAgreed]); //currentuserid

  return (
    <div style={{
      backgroundColor: 'white',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      minHeight: '100vh'
    }}>
      <br />
      <h2 style={{
        textAlign: 'center',
        color: 'blue',
        fontWeight: 'bold',
        fontSize: '2.2em'
      }}>
        Welcome, {username}
      </h2>
      <br />
      <div
        style={{
          fontFamily: 'Georgia, serif',
          border: '2px solid black',
          borderRadius: '10px',
          padding: '10px',
          textAlign: 'center',
          maxWidth: '500px',
          margin: '0 auto'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            justifyContent: 'center'
          }}
        >
          <button
            onClick={navigateToCategoryPage}
            type="submit"
            style={{
              flex: '1 1 220px',
              minWidth: '150px',
              height: '40px',
              backgroundColor: 'blue',
              color: 'white',
              borderRadius: '5px',
              border: '0',
              fontFamily: 'Georgia, serif',
              fontSize: '16px',
              fontWeight: 'bold',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            <span role="img" aria-label="category" style={{ marginRight: '8px' }}>❓</span>
            Questions
          </button>
          {showChallenges && (
            <button
              onClick={navigatetoChallengesPage}
              type="submit"
              style={{
                flex: '1 1 220px',
                minWidth: '150px',
                height: '40px',
                backgroundColor: 'blue',
                color: 'white',
                borderRadius: '5px',
                border: '0',
                fontFamily: 'Georgia, serif',
                fontSize: '16px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <span role="img" aria-label="more" style={{ marginRight: '8px' }}>🔧</span>
              Challenges
            </button>
          )}
          {showMyFriends && (
            <button
              onClick={navigateToFriendsPage}
              type="submit"
              style={{
                flex: '1 1 220px',
                minWidth: '150px',
                height: '40px',
                backgroundColor: 'blue',
                color: 'white',
                borderRadius: '5px',
                border: '0',
                fontFamily: 'Georgia, serif',
                fontSize: '16px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <span role="img" aria-label="friends" style={{ marginRight: '8px' }}>👥</span>
              My Friends
            </button>
          )}
          {showMyTeam && (
            <button
              onClick={navigateToTeamPage}
              type="submit"
              style={{
                flex: '1 1 220px',
                minWidth: '150px',
                height: '40px',
                backgroundColor: 'blue',
                color: 'white',
                borderRadius: '5px',
                border: '0',
                fontFamily: 'Georgia, serif',
                fontSize: '16px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <span role="img" aria-label="team" style={{ marginRight: '8px' }}>🧑‍🤝‍🧑</span>
              My Referrals ({teamCount})
            </button>
          )}
          {showMyPoints && (
            <button
              onClick={navigatetoPointsPage}
              type="submit"
              style={{
                flex: '1 1 220px',
                minWidth: '150px',
                height: '40px',
                backgroundColor: 'blue',
                color: 'white',
                borderRadius: '5px',
                border: '0',
                fontFamily: 'Georgia, serif',
                fontSize: '16px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <span role="img" aria-label="points" style={{ marginRight: '8px' }}>🥇</span>
               Points History ({points})
            </button>
          )}
          {showVouchers && (
            <button
              onClick={navigateToVouchersPage}
              type="submit"
              style={{
                flex: '1 1 220px',
                minWidth: '150px',
                height: '40px',
                backgroundColor: 'blue',
                color: 'white',
                borderRadius: '5px',
                border: '0',
                fontFamily: 'Georgia, serif',
                fontSize: '16px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <span role="img" aria-label="vouchers" style={{ marginRight: '8px' }}>🎁</span>
              My Vouchers ({voucherCount})
            </button>
          )}
          <button
            onClick={navigatetoKnowledgeScorePage}
            type="submit"
            style={{
              flex: '1 1 220px',
              minWidth: '150px',
              height: '40px',
              backgroundColor: 'blue',
              color: 'white',
              borderRadius: '5px',
              border: '0',
              fontFamily: 'Georgia, serif',
              fontSize: '16px',
              fontWeight: 'bold',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            <span role="img" aria-label="more" style={{ marginRight: '8px' }}>🔧</span>
            My Knowledge Graph
          </button>
          {showLeaderboard && (
            <button
              onClick={navigatetoLeaderboardPage}
              type="submit"
              style={{
                flex: '1 1 220px',
                minWidth: '150px',
                height: '40px',
                backgroundColor: 'blue',
                color: 'white',
                borderRadius: '5px',
                border: '0',
                fontFamily: 'Georgia, serif',
                fontSize: '16px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <span role="img" aria-label="more" style={{ marginRight: '8px' }}>🔧</span>
              Leaderboard
            </button>
          )}
          <button
            onClick={() => {
              logUserAction(currentuserid, 'Profile page: clicked About Us button');
              window.location.href = window.location.pathname + "?pageName=AboutUs&userid=" + currentuserid;
            }}
            type="submit"
            style={{
              flex: '1 1 220px',
              minWidth: '150px',
              height: '40px',
              backgroundColor: 'blue',
              color: 'white',
              borderRadius: '5px',
              border: '0',
              fontFamily: 'Georgia, serif',
              fontSize: '16px',
              fontWeight: 'bold',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            <span role="img" aria-label="about us" style={{ marginRight: '8px' }}>ℹ️</span>
            About Us
          </button>
          {isguest === 'true' && (
            <button
              onClick={navigatetoLoginPage}
              type="submit"
              style={{
                flex: '1 1 220px',
                minWidth: '150px',
                height: '40px',
                backgroundColor: 'blue',
                color: 'white',
                borderRadius: '5px',
                border: '0',
                fontFamily: 'Georgia, serif',
                fontSize: '16px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <span role="img" aria-label="login" style={{ marginRight: '8px' }}>🔑</span>
              Log in
            </button>
          )}
        </div>
      </div>

      {userStats && userStats.userStats && (
        <div style={{
          marginTop: '30px',
          maxWidth: '600px',
          marginLeft: 'auto',
          marginRight: 'auto',
          background: '#f4f8fb',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
          padding: '24px'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{
              textAlign: 'center',
              color: '#1a237e',
              fontWeight: 'bold',
              marginBottom: '18px',
              fontSize: '1.3em'
            }}>My Points Summary</h3>
            <button
              onClick={() => fetchUserStats()}
              style={{
                padding: '6px 12px',
                backgroundColor: '#1a73e8',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.9em'
              }}
            >
              Refresh
            </button>
          </div>
          <table style={{
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: '0',
            background: '#fff',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
          }}>
            <thead>
              <tr style={{ background: '#e3eafc' }}>
                <th style={{
                  padding: '12px 16px',
                  fontWeight: '700',
                  color: '#283593',
                  borderRight: '1px solid #e3e3e3',
                  fontSize: '1em',
                  textAlign: 'left'
                }}>Category</th>
                <th style={{
                  padding: '12px 16px',
                  fontWeight: '700',
                  color: '#283593',
                  borderRight: '1px solid #e3e3e3',
                  fontSize: '1em',
                  textAlign: 'center'
                }}>Total</th>
                <th style={{
                  padding: '12px 16px',
                  fontWeight: '700',
                  color: '#388e3c',
                  borderRight: '1px solid #e3e3e3',
                  fontSize: '1em',
                  textAlign: 'center'
                }}>Correct</th>
                <th style={{
                  padding: '12px 16px',
                  fontWeight: '700',
                  color: '#d32f2f',
                  fontSize: '1em',
                  textAlign: 'center'
                }}>Incorrect</th>
                <th style={{
                  padding: '12px 16px',
                  fontWeight: '700',
                  color: '#283593',
                  fontSize: '1em',
                  textAlign: 'center'
                }}>Accuracy</th>
              </tr>
            </thead>
            <tbody>
            {Object.entries(userStats.userStats).map(([category, stats]) => (
              <tr key={category}>
                <td style={{ padding: '12px 16px', borderRight: '1px solid #e3e3e3' }}>{category}</td>
                <td style={{ padding: '12px 16px', textAlign: 'center', borderRight: '1px solid #e3e3e3' }}>{stats.Total}</td>
                <td style={{ padding: '12px 16px', textAlign: 'center', borderRight: '1px solid #e3e3e3', color: '#388e3c' }}>{stats.Correct}</td>
                <td style={{ padding: '12px 16px', textAlign: 'center', color: '#d32f2f' }}>{stats.InCorrect}</td>
                <td style={{ padding: '12px 16px', textAlign: 'center' }}>{stats.Accuracy}</td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      )}
      {overlayContent && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '500px',
            textAlign: 'center'
          }}>
            <h2>{overlayContent.title}</h2>
            <p>{overlayContent.content}</p>
            <div style={{ marginTop: '20px' }}>
              <button
                onClick={overlayContent.onAccept}
                style={{
                  marginRight: '10px',
                  padding: '10px 20px',
                  backgroundColor: 'green',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                {overlayContent.acceptButtonText || "Accept"}
              </button>
              <button
                onClick={overlayContent.onReject}
                style={{
                  padding: '10px 20px',
                  backgroundColor: 'red',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                {overlayContent.rejectButtonText || "Reject"}
              </button>
            </div>
          </div>
        </div>
      )}
      <style>
        {`
          @media (max-width: 600px) {
            h2 {
              font-size: 1.4em !important;
            }
            div[style*="border: 2px solid black"] {
              padding: 5px !important;
            }
            button {
              font-size: 14px !important;
              height: 38px !important;
              min-width: 120px !important;
            }
            table {
              font-size: 0.95em !important;
            }
            td, th {
              padding: 8px !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default Profile;